import React, { Fragment, useState, useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {
    Card,
    CardBody,
    Container
} from "reactstrap";
import { Col, Row } from "react-bootstrap";
import CommonHeaderContent from '../../Common/CommonHeaderContent';
import CardPanel from './CardPanel';
import { defaultPrimaryCardStyles } from './Constants';

const KPIChartModal = (props) => {
    let { isModalOpen, closeModal, openChartConfig, primaryChartType } = props;
    let chartItems = defaultPrimaryCardStyles;
    return (
        <Modal isOpen={isModalOpen} className={"kpi-chart-modal le-modal-lg campaign-modal"}>
            <ModalBody>
                <Fragment>
                    <CommonHeaderContent
                        isModal={true}
                        closeModal={closeModal}
                        buttonTxt={""}
                        headerTitle={"Choose KPI Style"}
                        isClassNeeded={false}
                        mainContent={
                            <div className='ml-2 mt-3'>
                                <Row>
                                    {
                                        Object.keys(chartItems).map((chartType, index) => {
                                            let chartInfo = chartItems[chartType];
                                            let name = chartInfo['name'];
                                            let sumvalue = chartInfo['sumvalue'];
                                            let countvalue = chartInfo['countvalue'];
                                            return (
                                                <CardPanel openChartConfig={openChartConfig} md="5" type={chartType} name={name} countvalue={countvalue} sumvalue={sumvalue} primaryChartType={primaryChartType} />
                                            )
                                        })
                                    }
                                </Row>
                            </div>
                        } />
                </Fragment>
            </ModalBody>
        </Modal>
    )
}

export default KPIChartModal;